<template>
    <div class="section">
        <div class="tile is-5">
            <div class="tile is-child box">
                <b-loading :active="loading"></b-loading>
                <b-message v-if="sended.message" :type="sended.type" has-icon>
                    <p v-text="sended.message" class="mb-2"></p>
                </b-message>
                <input type="hidden" name="entity" :value="entityType" />
                <div class="columns">
                    <div class="column">
                        <p class="subtitle">Create new permission</p>
                    </div>
                </div>
                <b-field label="Name">
                    <b-input v-model="permissionName" type="text" name="name"></b-input>
                </b-field>
                <b-button v-if="isMultipleButton()"
                          v-for="(button, index) in buttons" :key="index" :tag="button.buttonTag"
                          size="is-small" class="clear form-buttons" :type="button.buttonType"
                          :href="button.buttonAction" :native-type="button.buttonNativeType"
                          @click.prevent="submit(button.buttonTag, button.buttonAction)"
                          :icon-left="button.buttonIcon" :label="button.buttonLabel">
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            buttons: {
                type: [Array, Object]
            },
            formAction: String,
            entityType: String,
            componentTitle: String,
            buttonAction: String,
            buttonLabel: String,
            buttonIcon: String,
            buttonType: String,
            buttonTag: String,
            buttonNativeType: String,
            permissionName: String,
        },
        data() {
            return {
                input: {},
                sended: {
                    message: "",
                    type: 'is-success'
                },
                loading: false
            }
        },
        created() {
            // for (let key of Object.keys(this.entity)) {
            //     this.input[key] = this.entity[key];
            // }
        },
        methods: {
            log(message) {
                console.log(message);
            },
            canShow(visibility) {
                return Boolean(visibility !== "false");
            },
            isMultipleButton() {
                return !!this.buttons.length;
            },
            submit(buttonTag, buttonAction) {
                if (buttonTag === "a") {
                    window.location.href = buttonAction;
                }else{
                    this.loading = true;
                    this.input['name'] = this.permissionName;
                    this.input['entity'] = this.entityType;
                    axios
                        .post(this.formAction, this.input)
                        .then(result => {
                            this.sended.message = result.data.msg;
                            this.sended.type = 'is-' + result.data.type;
                            this.loading = false;
                            // window.location.href =
                            //     "http://tesshub.test/dashboard/source/index";
                            //this.$router.push({ name: "source" });
                        })
                        .catch(error => {
                            this.errors = error.response.data.errors;
                            this.loading = false;
                        });
                }


            }
        }
    }
</script>
